import { css } from "@emotion/core"
import theme from "./Theme"

const GlobalStyle = css`
  html {
    box-sizing: border-box;
    overflow-y: scroll;
    font-size: 50%;
    margin: 0;
    padding: 0;
    height: 100%;

    @media (max-width: ${theme.breakpoints[0]}) {
      font-size: 40%;
    }
  }
  body {
    min-height: 100%;
    width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;

    font-family: "Lato", Helvetica, sans-serif;

    background: white;

    font-size: 2rem;
    line-height: 1.5;

    color: #3c2413;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0 0 1.5rem;
      padding: 0;
      font-weight: 900;
      text-transform: uppercase;
    }

    h1 {
      font-size: 10rem;
    }

    h2 {
      font-size: 4.5rem;
    }

    h3 {
      font-size: 4rem;
    }

    h4 {
      font-size: 2.9rem;
    }

    h5,
    button {
      font-size: 2.6rem;
    }

    h6 {
      font-size: 2.2rem;
    }

    header {
      z-index: 5000;
    }

    a {
      text-decoration: none;
      color: ${theme.colors.primary};
      transition: color 0.2s ease-in-out;

      &:hover {
        color: ${theme.colors.primaryHover};
      }
    }

    .site-content {
      min-height: calc(100vh - 235px);
    }

    &.no-scroll {
      position: fixed;
      overflow-y: scroll;
    }

    .show-tablet {
      display: none;
    }

    .multi-family-button {
      padding: 15px 25px;
      position: relative;
      top: -5rem;
      color: white;
      background: ${theme.colors.primary};
      text-transform: uppercase;
      font-weight: bold;

      &:hover {
        background: ${theme.colors.primaryHover};
        color: white;
      }
    }

    @media (max-width: ${theme.breakpoints[1]}) {
      .hide-tablet {
        display: none;
      }

      .show-tablet {
        display: initial;
      }
    }

    .wp-block-media-text {
      figure {
        float: right;
        align-self: center;

        @media (max-width: ${theme.breakpoints[2]}) {
          float: none;
        }

        img {
          max-width: 350px;

          @media (max-width: ${theme.breakpoints[2]}) {
            max-width: 100%;
          }
        }
      }
    }

    .ReactModal__Overlay--after-open {
      z-index: 11000 !important;
    }

    .has-background {
      padding: 20px 30px
    }

    .has-pale-pink-background-color {
      background-color: #f78da7
    }

    .has-vivid-red-background-color {
        background-color: #cf2e2e
    }

    .has-luminous-vivid-orange-background-color {
        background-color: #ff6900
    }

    .has-luminous-vivid-amber-background-color {
        background-color: #fcb900
    }

    .has-light-green-cyan-background-color {
        background-color: #7bdcb5
    }

    .has-vivid-green-cyan-background-color {
        background-color: #00d084
    }

    .has-pale-cyan-blue-background-color {
        background-color: #8ed1fc
    }

    .has-vivid-cyan-blue-background-color {
        background-color: #0693e3
    }

    .has-very-light-gray-background-color {
        background-color: #eee
    }

    .has-cyan-bluish-gray-background-color {
        background-color: #abb8c3
    }

    .has-very-dark-gray-background-color {
        background-color: #313131
    }

    .has-pale-pink-color {
        color: #f78da7
    }

    .has-vivid-red-color {
        color: #cf2e2e
    }

    .has-luminous-vivid-orange-color {
        color: #ff6900
    }

    .has-luminous-vivid-amber-color {
        color: #fcb900
    }

    .has-light-green-cyan-color {
        color: #7bdcb5
    }

    .has-vivid-green-cyan-color {
        color: #00d084
    }

    .has-pale-cyan-blue-color {
        color: #8ed1fc
    }

    .has-vivid-cyan-blue-color {
        color: #0693e3
    }

    .has-very-light-gray-color {
        color: #eee
    }

    .has-cyan-bluish-gray-color {
        color: #abb8c3
    }

    .has-very-dark-gray-color {
        color: #313131
    }

    .has-small-font-size {
      font-size: 13px;
    }

    .has-regular-font-size,
    .has-normal-font-size {
      font-size: 16px;
    }

    .has-medium-font-size {
      font-size: 20px;
    }

    .has-large-font-size {
      font-size: 36px;
    }

    .has-larger-font-size,
    .has-huge-font-size {
      font-size: 42px;
    }
  }
`

export default GlobalStyle
